module.exports = __webpack_public_path__ + "static/media/empty.5b0f5285.svg";